/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import LayoutFooter from "../inc/LayoutFooter";
import LayoutHeader from "../inc/LayoutHeader";
import { RollbackOutlined } from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";
import { Layout, Col, Row, Select } from "antd";
import { Button, Card, Form, Input, Spin } from "antd";
import { displayMessage, postAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import {
  EDIT_DYNAMIC_CONTENT,
  DYNAMIC_CONTENT_BY_ID,
} from "../../constants/api";
import JoditEditor from "jodit-react";
import { DYNAMIC_PAGE_TYPE } from "../../constants/constent";

function PagesUpdate() {
  const { Content } = Layout;
  const { id } = useParams();
  let history = useNavigate();
  let navigate = useNavigate();

  const [form] = Form.useForm();
  const [loading, setIsLoading] = useState(false);

  useLayoutEffect(() => {
    getIdDetail();
  }, []);
  const getIdDetail = () => {
    setIsLoading(true);
    var data = new FormData();
    data.append("id", id);
    const successFn = function (data) {
      if (data.status === true) {
        form.setFieldsValue({
          title: data.data.title,
          description: data.data.description,
          type: data.data.type,
        });
        setIsLoading(false);
      } else {
        setIsLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Get Data");
    };
    postAPI(DYNAMIC_CONTENT_BY_ID, data, successFn, errorFn);
  };

  const updateData = (values) => {
    setIsLoading(true);
    const data = new FormData();
    data.append("id", id);
    if (values.title) {
      data.append("title", values.title);
    }
    if (values.description) {
      data.append("description", values.description);
    }
    if (values.type) {
      data.append("type", values.type);
    }
    const successFn = function (data) {
      if (data.status === true) {
        setIsLoading(false);
        history("/pages");
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setIsLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Update Data");
    };
    postAPI(EDIT_DYNAMIC_CONTENT, data, successFn, errorFn);
  };
  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Update Pages"
            bordered={false}
            extra={
              <Button
                style={{
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
                onClick={() => navigate(-1)}
                type="primary"
                ghost
              >
                <RollbackOutlined />
              </Button>
            }
          >
            <Spin spinning={loading}>
              <Form form={form} layout="vertical" onFinish={updateData}>
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Form.Item
                      name="title"
                      label="Title"
                      rules={[{ required: false }]}
                    >
                      <Input type={"text"} placeholder="Title" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="type"
                      label="Page For"
                      rules={[{ required: true }]}
                    >
                      <Select
                        showSearch
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        placeholder="Select a page for"
                        optionFilterProp="label"
                        options={DYNAMIC_PAGE_TYPE}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      name="description"
                      label="Description"
                      rules={[{ required: true }]}
                    >
                      <JoditEditor placeholder="Description" />
                    </Form.Item>
                  </Col>
                </Row>

                <Row spceber>
                  <Col span={24}>
                    <Form.Item
                      style={{ float: "right" }}
                      label=""
                      colon={false}
                    >
                      <Button loading={loading} block htmlType="submit">
                        Update
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Spin>
          </Card>
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}
export default PagesUpdate;
